module.exports = __webpack_public_path__ + "img/VsLotion1.2fe86a6c.jpg";